<template>
  <f7-page>
    <!-- <f7-navbar title="Left Panel"></f7-navbar> -->
    <div class="hero-image">
      <f7-link raised panel-close="left" style="position: absolute; right: 20px; top: 20px;">
        <img panel-close="left" src="assets/img/cerrar-menu-lateral.png" alt="" width="20">
      </f7-link>
      <div class="hero-text">
        <h3 class="font-trajan">Nos especializamos en "¡Dios mío, me encanta!"</h3>
      </div>
      <div class="version">
        v {{ $f7.version }}
      </div>
    </div>
    <!-- <f7-row class="m-t-40">
      <f7-col class="text-center">
        <img src="@/assets/img/logo_250.png" alt="" width="100">
      </f7-col>
    </f7-row> -->

    <f7-list class="m-b-0 m-t-0" accordion-list>
      <f7-list-item class="custom-acc" accordion-item title="Anillo de Compromiso">
        <f7-icon slot="media">
          <img class="m-l-0" src="assets/img/menu/compromiso.svg" alt="" width="35">
        </f7-icon>
        <f7-accordion-content>
          <f7-block>
            <p class="text-uppercase fs-12 bold">
              Diseña tu anillo de compromiso
            </p>
          </f7-block>
          <f7-row class="p-l-15 m-b-10">
            <f7-col>
              <f7-link href="/compromiso/" view="#main-view" panel-close>
                <img class="m-r-15" src="assets/img/menu/montadura.svg" width="30" alt="">
                <span class="">
                  Comienza con una montura
                </span>
              </f7-link>
            </f7-col>
          </f7-row>
          <f7-row class="p-l-15">
            <f7-col>
              <f7-link href="/diamantes/" view="#main-view" panel-close>
                <img class="m-r-15" src="assets/img/menu/diamantes.svg" width="30" alt="">
                <span class="">
                  Comienza con un diamante
                </span>
              </f7-link>
            </f7-col>
          </f7-row>
          <f7-block class="m-t-30 m-b-15">
            <p class="text-uppercase fs-12 bold">
              Estilos de anillo de compromiso
            </p>
            <f7-row class="m-t-10">
              <f7-col class="p-5">
                <f7-link href="/compromiso/" view="#main-view" panel-close @click="$f7.router.context = { decorativa: 'solitario' }">
                  <img class="m-r-15" src="assets/img/estilos/solitario.svg" width="45" alt="">
                  <span>Solitario</span>
                </f7-link>
              </f7-col>
              <f7-col class="p-5">
                <f7-link href="/compromiso/" view="#main-view" panel-close @click="$f7.router.context = { decorativa: 'pave' }">
                  <img class="m-r-15" src="assets/img/estilos/pave.svg" width="45" alt="">
                  <span>Pave</span>
                </f7-link>
              </f7-col>
            </f7-row>
            <f7-row class="m-t-10">
              <f7-col class="p-5">
                <f7-link href="/compromiso/" view="#main-view" panel-close @click="$f7.router.context = { decorativa: 'chanel' }">
                  <img class="m-r-15" src="assets/img/estilos/channel.svg" width="45" alt="">
                  <span>Channel</span>
                </f7-link>
              </f7-col>
              <f7-col class="p-5">
                <f7-link href="/compromiso/" view="#main-view" panel-close @click="$f7.router.context = { decorativa: 'laterales' }">
                  <img class="m-r-15" src="assets/img/estilos/lateral.svg" width="45" alt="">
                  <span>Laterales</span>
                </f7-link>
              </f7-col>
            </f7-row>
            <f7-row class="m-t-10">
              <f7-col class="p-5">
                <f7-link href="/compromiso/" view="#main-view" panel-close @click="$f7.router.context = { decorativa: '3 piedras' }">
                  <img class="m-r-15" src="assets/img/estilos/piedras3.svg" width="45" alt="">
                  <span>3 Piedras</span>
                </f7-link>
              </f7-col>
              <f7-col class="p-5">
                <f7-link href="/compromiso/" view="#main-view" panel-close @click="$f7.router.context = { decorativa: 'halo' }">
                  <img class="m-r-15" src="assets/img/estilos/halo.svg" width="45" alt="">
                  <span>Halo</span>
                </f7-link>
              </f7-col>
            </f7-row>
          </f7-block>
          <!-- <f7-row>
            <img width="100%" src="//ion.r2net.com/Images/MobileTest/SplashPages/EngagementSplash/menu-link-bg.jpg">
          </f7-row> -->
        </f7-accordion-content>
      </f7-list-item>
      <f7-list-item class="custom-acc" accordion-item title="Diamantes">
        <f7-icon slot="media">
          <img class="m-l-0" src="assets/img/menu/diamantes.svg" alt="" width="30">
        </f7-icon>
        <f7-accordion-content>
          <f7-block>
            <p class="text-uppercase fs-12 bold">
              Diseña tu anillo de compromiso
            </p>
          </f7-block>
          <f7-row class="p-l-15 m-b-10">
            <f7-col>
              <f7-link href="/diamantes/" view="#main-view" panel-close>
                <img class="m-r-15" src="assets/img/menu/diamantes.svg" width="30" alt="">
                <span class="">
                  Comienza con un diamante
                </span>
              </f7-link>
            </f7-col>
          </f7-row>
          <f7-row class="p-l-15">
            <f7-col>
              <f7-link href="/compromiso/" view="#main-view" panel-close>
                <img class="m-r-15" src="assets/img/menu/montadura.svg" width="30" alt="">
                <span class="">
                  Comienza con una montura
                </span>
              </f7-link>
            </f7-col>
          </f7-row>
          <f7-block class="m-t-30 m-b-30">
            <p class="text-uppercase fs-12 bold">
              Corte de Diamantes
            </p>
            <f7-row class="m-t-10">
              <f7-col>
                <f7-link href="/diamantes/" view="#main-view" panel-close @click="$f7.router.context = { forma: 'redondo' }">
                  <img class="m-r-15" src="assets/img/corte/redondo.svg" width="40" alt="">
                  <span>Redondo</span>
                </f7-link>
              </f7-col>
              <f7-col>
                <f7-link href="/diamantes/" view="#main-view" panel-close @click="$f7.router.context = { forma: 'radiant' }">
                  <img class="m-r-15" src="assets/img/corte/radiant.svg" width="40" alt="">
                  <span>Radiant</span>
                </f7-link>
              </f7-col>
            </f7-row>
            <f7-row class="m-t-10">
              <f7-col>
                <f7-link href="/diamantes/" view="#main-view" panel-close @click="$f7.router.context = { forma: 'princesa' }">
                  <img class="m-r-15" src="assets/img/corte/princess.svg" width="40" alt="">
                  <span>Princesa</span>
                </f7-link>
              </f7-col>
              <f7-col>
                <f7-link href="/diamantes/" view="#main-view" panel-close @click="$f7.router.context = { forma: 'asscher' }">
                  <img class="m-r-15" src="assets/img/corte/asscher.svg" width="40" alt="">
                  <span>Asscher</span>
                </f7-link>
              </f7-col>
            </f7-row>
            <f7-row class="m-t-10">
              <f7-col>
                <f7-link href="/diamantes/" view="#main-view" panel-close @click="$f7.router.context = { forma: 'cushion' }">
                  <img class="m-r-15" src="assets/img/corte/cushion.svg" width="40" alt="">
                  <span>Cushion</span>
                </f7-link>
              </f7-col>
              <f7-col>
                <f7-link href="/diamantes/" view="#main-view" panel-close @click="$f7.router.context = { forma: 'marquesa' }">
                  <img class="m-r-15" src="assets/img/corte/marquesa.svg" width="40" alt="">
                  <span>Marquesa</span>
                </f7-link>
              </f7-col>
            </f7-row>
            <f7-row class="m-t-10">
              <f7-col>
                <f7-link href="/diamantes/" view="#main-view" panel-close @click="$f7.router.context = { forma: 'esmeralda' }">
                  <img class="m-r-15" src="assets/img/corte/esmeralda.svg" width="40" alt="">
                  <span>Emeralda</span>
                </f7-link>
              </f7-col>
              <f7-col>
                <f7-link href="/diamantes/" view="#main-view" panel-close @click="$f7.router.context = { forma: 'corazón' }">
                  <img class="m-r-15" src="assets/img/corte/corazon.svg" width="40" alt="">
                  <span>Corazón</span>
                </f7-link>
              </f7-col>
            </f7-row>
            <f7-row class="m-t-10">
              <f7-col>
                <f7-link href="/diamantes/" view="#main-view" panel-close @click="$f7.router.context = { forma: 'ovalado' }">
                  <img class="m-r-15" src="assets/img/corte/ovalado.svg" width="40" alt="">
                  <span>Óvalo</span>
                </f7-link>
              </f7-col>
              <f7-col>
                <f7-link href="/diamantes/" view="#main-view" panel-close @click="$f7.router.context = { forma: 'pera' }">
                  <img class="m-r-15" src="assets/img/corte/pera.svg" width="40" alt="">
                  <span>Pera</span>
                </f7-link>
              </f7-col>
            </f7-row>
          </f7-block>
          <!-- <f7-row>
            <img width="100%" src="//ion.r2net.com/Images/MobileTest/SplashPages/DiamondsSplash/menu-link-bg.jpg">
          </f7-row> -->
        </f7-accordion-content>
      </f7-list-item>
      <f7-list-item class="custom-acc" link="/promesa/" title="Promesa" view="#main-view" badge="DIAMANTE" :no-chevron="true" panel-close>
        <f7-icon class="w-25" slot="media">
          <img class="m-l-0" src="assets/img/menu/promesa.svg" alt="" width="35">
        </f7-icon>
      </f7-list-item>
      <f7-list-item class="custom-acc" link="/churumbela/" title="Churumbela" view="#main-view" badge="DIAMANTE" :no-chevron="true" panel-close>
        <f7-icon class="w-25" slot="media">
          <img class="m-l-0" src="assets/img/menu/churumbela.svg" alt="" width="35">
        </f7-icon>
      </f7-list-item>
      <f7-list-item class="custom-acc" link="/argolla/" title="Argolla" view="#main-view" :no-chevron="true" panel-close>
        <f7-icon class="w-25" slot="media">
          <img class="m-l-0" src="assets/img/menu/argolla.svg" alt="" width="35">
        </f7-icon>
      </f7-list-item>
      <f7-list-item class="custom-acc" link="/zirconia/" title="Anillos" view="#main-view" badge="CIRCONIA" :no-chevron="true" panel-close>
        <f7-icon class="w-25" slot="media">
          <img class="m-l-0" src="assets/img/menu/zirconia.svg" alt="" width="35">
        </f7-icon>
      </f7-list-item>
      <f7-list-item class="custom-acc" link="/cadenas/" title="Cadenas" view="#main-view" :no-chevron="true" panel-close>
        <f7-icon class="w-25" slot="media">
          <img class="m-l-0" src="assets/img/menu/cadenas.svg" alt="" width="35">
        </f7-icon>
      </f7-list-item>
      <f7-list-item class="custom-acc hide" link="/pulseras/" title="Pulseras" view="#main-view" :no-chevron="true" panel-close>
        <f7-icon class="w-25" slot="media">
          <img class="m-l-0" src="assets/img/menu/pulsera.svg" alt="" width="35">
        </f7-icon>
      </f7-list-item>
      <f7-list-item class="custom-acc" link="/aretes/" title="Aretes" view="#main-view" :no-chevron="true" panel-close>
        <f7-icon class="w-25" slot="media">
          <img class="m-l-0" src="assets/img/menu/aretes.svg" alt="" width="35">
        </f7-icon>
      </f7-list-item>
      <f7-list-item class="custom-acc" link="/dijes/" title="Dijes" view="#main-view" :no-chevron="true" panel-close>
        <f7-icon class="w-25" slot="media">
          <img class="m-l-0" src="assets/img/menu/dijes.svg" alt="" width="35">
        </f7-icon>
      </f7-list-item>
      <f7-list-item class="custom-acc" link="/pulseras/" title="Pulso" view="#main-view" :no-chevron="true" panel-close>
        <f7-icon class="w-25" slot="media">
          <img class="m-l-0" src="assets/img/menu/pulsera.svg" alt="" width="35">
        </f7-icon>
      </f7-list-item>
      <f7-list-item class="custom-acc" link="/conjuntos/" title="Conjuntos" view="#main-view" :no-chevron="true" panel-close>
        <f7-icon class="w-25" slot="media">
          <img class="m-l-0" src="assets/img/menu/conjuntos.svg" alt="" width="35">
        </f7-icon>
      </f7-list-item>
      <f7-list-item class="custom-acc" link="/personalizado/" title="Diseño Personalizado" view="#main-view" :no-chevron="true" panel-close>
        <f7-icon class="w-25" slot="media">
          <img class="m-l-0" src="assets/img/menu/ringmaker.svg" alt="" width="35">
        </f7-icon>
      </f7-list-item>
    </f7-list>
    <!-- <f7-block-title>Load page in main view</f7-block-title> -->
    <f7-list class="custom-list m-t-0">
      <f7-list-item class="custom-acc" link="/sesion/" title="Mi Cuenta" view="#main-view" :no-chevron="true" panel-close></f7-list-item>
      <f7-list-item class="custom-acc" link="/acerca/" title="¿Quiénes Somos?" view="#main-view" :no-chevron="true" panel-close></f7-list-item>
      <f7-list-item class="custom-acc" link="/porque/" title="¿Porqué comprar con Madai?" view="#main-view" :no-chevron="true" panel-close></f7-list-item>
      <f7-list-item class="custom-acc" link="/aviso/" title="Aviso de Privacidad" view="#main-view" :no-chevron="true" panel-close></f7-list-item>
      <f7-list-item class="custom-acc" link="/terminos/" title="Términos y Condiciones" view="#main-view" :no-chevron="true" panel-close></f7-list-item>
      <f7-list-item class="custom-acc" link="/ubicacion/" title="¿Dónde estamos?" view="#main-view" :no-chevron="true" panel-close></f7-list-item>
      <f7-list-item class="custom-acc" link="/contacto/" title="Contacto" view="#main-view" :no-chevron="true" panel-close></f7-list-item>
    </f7-list>
    <f7-block class="text-center fs-12">
      <f7-row>
        <f7-col class="text-center">
          <img src="@/assets/img/logo_250.png" alt="" width="50">
        </f7-col>
      </f7-row>
      <!-- <f7-row>
        <f7-col class="text-center">
          v {{ $f7.version }}
        </f7-col>
      </f7-row> -->
    </f7-block>
  </f7-page>
</template>

<script>
export default {}
</script>

<style>
.item-media-custom .item-media {
  min-width: auto !important;
}

.p-c {
  font-family: 'anillo';
  font-size: 50px;
  line-height: 25px;
}

.hero-image {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("/assets/img/banners/hero-menu.jpg");
  height: 25%;
  background-position: right;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.hero-text {
  /* color: white;
  left: 50%;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 300px; */
  color: white;
  left: 45%;
  position: absolute;
  text-align: center;
  top: 30px;
  font-size: 14px;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 255px;
}

.version {
  bottom: 10px;
  color: white;
  font-size: 11px;
  font-weight: bold;
  position: absolute;
  right: 10px;
  z-index: 99;
}
</style>
